// Publishable key only — safe to ship in the browser bundle. Set
// REACT_APP_STRIPE_PUBLISHABLE_KEY at build time (test key for staging,
// live key for production).
export const stripePublishableKey =
  process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
  "pk_test_51MtB7dGSvR6PfETC5VDMQREgXPgafBDs1wrEN5S2796OB1fa4mN8poWJe8SnDRsIjZHV5Yd79ePegFnntp2cjtmW0021ZeWb0D";
